import React from "react";
import ReactDOM from "react-dom/client";
import LoginScreen from "./screens/login/login";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import { BrowserRouter, Routes, Route } from "react-router";
import SignupScreen from "./screens/sign-up/sign-up";
import HomeScreen from "./screens/home/home";
import { configureStore } from "@reduxjs/toolkit";
import { logger } from "redux-logger";
import { Provider } from "react-redux";
import MainReducer from "./redux/reducer";
import { Toaster } from "react-hot-toast";

import { auth, onAuthStateChanged } from "./utils/firebase-config";
const store = configureStore({
  reducer: MainReducer,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(logger),
});

onAuthStateChanged(auth, (user) => {
  console.log(user);
  if (user) {
    localStorage.setItem("user_id", user.uid);
  } else {
    localStorage.removeItem("user_id");
  }
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <Toaster />
        <Routes>
          <Route path="/" element={<LoginScreen />} />
          <Route path="/signup" element={<SignupScreen />} />
          <Route path="/home" element={<HomeScreen />} />
        </Routes>
      </BrowserRouter>
    </Provider>
  </React.StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
